<div class="collapsible-content">
  <div class="collapsible-content-header" (click)="toggleCollapsed()">
    @if (collapseIconPosition() === CollapsibleContentIconPosition.left) {
      <mat-icon [svgIcon]="isCollapsed() ? 'chevron-down' : 'chevron-up'"></mat-icon>
    }
    <div class="font-label-large font-semi-bold">
      {{ titleText() }}
    </div>
    @if (collapseIconPosition() === CollapsibleContentIconPosition.right) {
      <mat-icon [svgIcon]="isCollapsed() ? 'chevron-down' : 'chevron-up'"></mat-icon>
    }
  </div>

  <div class="content font-secondary" [class.collapsed]="isCollapsed()">
    <ng-content></ng-content>
  </div>
</div>
